import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import TableActionButton from 'src/components/TableActionButton';
import CreateManagedBasePolicyModal from './CreateManagedBasePolicyModal';

const CreateManagedPolicyAction = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <TableActionButton
        variant="outlined"
        onClick={() => setOpen(true)}
        startIcon={<Iconify icon="mdi:shield-plus-outline" width={16} height={16} />}
        sx={{ px: 1.5 }}>
        Create Managed Policy
      </TableActionButton>
      <CreateManagedBasePolicyModal open={open} onDone={close} onClose={close} />
    </>
  );
};

export default CreateManagedPolicyAction;
